import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);

export default function useYupObject(): typeof yup {
  const { t } = useTranslation('forms');
  yup.setLocale({
    // https://github.com/jquense/yup/blob/master/src/locale.ts
    mixed: {
      required: t('mixed_required'),
      notType: t('mixed_notType'),
    },
    string: {
      email: t('string_email'),
      url: t('string_url'),
      max: ({ ...args }) => t('string_max', args),
    },
    number: {
      min: t('number_min'),
      moreThan: t('number_moreThan'),
      max: t('number_max'),
      integer: t('number_integer'),
      positive: t('number_positive'),
    },
    date: {
      min: ({ min }) => t('date_min', { min: dayjs(min).format('L LTS') }),
      max: ({ max }) => t('date_max', { max: dayjs(max).format('L LTS') }),
    },
  });

  yup.addMethod<yup.StringSchema>(
    yup.string,
    'noSpecialCharacters',
    function noSpecialCharacters() {
      return this.matches(/^[aA-zZ\s0-9]+$/, {
        message: t('string_noSpecialCharacters'),
        excludeEmptyString: true,
      });
    },
  );

  yup.addMethod<yup.StringSchema>(yup.string, 'phone', function phone() {
    return this.matches(/^[^A-Za-z]+$/, {
      message: t('string_phone'),
    });
  });

  return yup;
}
